<script setup lang="ts">
defineProps<{ data: TextProps; template?: 'page' | 'overlay' }>()
</script>

<template>
  <section
    class="px-bleed gap-gap grid py-4 lg:grid-cols-2"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey': template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <div class="flex flex-col gap-8 lg:col-start-2">
      <ElementsPortableTextWrapper class="text-lg" :content="data.subHeading" />
      <ElementsPortableTextWrapper :content="data.text" />
      <ElementsButton
        v-for="(link, index) in data.callToAction"
        :key="index"
        :link="link"
        class="w-fit text-(--page-cta-text) before:bg-(--page-cta-bg)"
      />
    </div>
  </section>
</template>
